<template>
	<div class="row">
        <div class="col-sm-12">
            <div class="ibox">
                <div class="ibox-content">
                    <span class="text-muted small float-right">Showing 1 to {{projects.length}} of {{totalProjects}} </span>
                    <h2>Schedule</h2>
                    <div class="input-group">
                        
                        <span class="input-group-btn">
                                <button type="button" class="btn btn btn-primary"> <i class="fa fa-search" v-show="!searching"></i> <i class="fa fa-spinner fa-spin" v-show="searching"></i> Search</button>
                        </span>
                    </div>

                    <div id="calendar"></div>
                   

                </div>
            </div>
        </div>   
   	</div>
</template>

<script>

    export default {
        data: function () {
            return {
                projects: [],
                current_page: 0,
                totalProjects: 0,
                loading: true,
                search_string: '',
                searching: false
            }
        },
        mounted: function() {
        	$('#calendar').fullCalendar({
        	schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
			now: '2016-01-07',
			editable: true,
			aspectRatio: 1.8,
			scrollTime: '00:00',
			header: {
				left: 'today prev,next',
				center: 'title',
				right: 'timelineDay,timelineThreeDays,agendaWeek,month'
			},
			defaultView: 'timelineWeek',
			slotDuration: {day: 1},
			resourceGroupField: 'building',
			resources: [
				{ id: 'a', building: 'Jason Smith', title: 'TDS' , children: [
					{ id: 's1', title: 'Story 1', occupancy: 10 },
					{ id: 's2', title: 'Story 2', occupancy: 10 }
				]},
				{ id: 'b', building: 'Jason Smith', title: 'LHD', eventColor: 'green' },
				{ id: 'c', building: 'Jason Smith', title: 'Auditorium C', eventColor: 'orange' },
				{ id: 'd', building: 'Jason Smith', title: 'Auditorium D', children: [
					{ id: 'd1', title: 'Room D1', occupancy: 10 },
					{ id: 'd2', title: 'Room D2', occupancy: 10 }
				] },
				{ id: 'e', building: 'Jason Smith', title: 'Auditorium E' },
				{ id: 'f', building: 'Jason Smith', title: 'Auditorium F', eventColor: 'red' },
				{ id: 'g', building: 'Sam Faulkner', title: 'Auditorium G' },
				{ id: 'h', building: 'Sam Faulkner', title: 'Auditorium H' },
			],
			events: [
				{ id: '1', resourceId: 'b', start: '2016-01-07', end: '2016-01-07', title: 'event 1' },
				{ id: '2', resourceId: 't1', start: '2016-01-04', end: '2016-01-07', title: 'event 1' },
				{ id: '3', resourceId: 'c', start: '2016-01-07', end: '2016-01-07', title: 'event 2' },
				{ id: '4', resourceId: 'd', start: '2016-01-06', end: '2016-01-08', title: 'event 3' },
				{ id: '5', resourceId: 'e', start: '2016-01-07', end: '2016-01-07', title: 'event 4' },
				{ id: '6', resourceId: 'f', start: '2016-01-07', end: '2016-01-07', title: 'event 5' }
			]
		});


        }
    }
</script>